<mat-card class="emergency-contacts-card">
  <mat-card-header>
    <mat-card-title>Emergency Contacts</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="emergencyContacts && emergencyContacts.length > 0; else noContacts">
      <div *ngFor="let contact of emergencyContacts; let i = index" class="contact-item">
        <div class="contact-header">
          <h4>Contact {{i + 1}}: {{contact.emergencyContactFirstName}} {{contact.emergencyContactLastName}}</h4>
          <div class="status-indicator">
            <mat-icon [class]="getStatusInfo(contact.inactiveFlag).class">
              {{getStatusInfo(contact.inactiveFlag).icon}}
            </mat-icon>
            <span [class]="getStatusInfo(contact.inactiveFlag).class">
              {{getStatusInfo(contact.inactiveFlag).text}}
            </span>
          </div>
        </div>
        
        <div class="contact-details">
          <div class="detail-grid">                        
            <div class="detail-item">
                <strong>Relationship:</strong>
                <span>{{formatFieldValue(contact.emergencyContactRelationshipValue)}}</span>
              </div>

            <div class="detail-item">
              <strong>Mobile Phone:</strong>
              <span>{{formatPhoneNumber(contact.emergencyContactMobilePhone)}}</span>
            </div>
            
            <div class="detail-item">
                <strong>Contact Type:</strong>
                <span>{{formatFieldValue(contact.emergencyContactType)}}</span>
            </div>

            <div class="detail-item">
              <strong>Telephone:</strong>
              <span>{{formatPhoneNumber(contact.emergencyContactTelephone)}}</span>
            </div>
            
            <div class="detail-item">
                <strong>Change Date:</strong>
                <span>{{formatDate(contact.changeDate)}}</span>
              </div>
            
            <div class="detail-item">
              <strong>Work Phone:</strong>
              <span>{{formatPhoneNumber(contact.emergencyContactWorkPhone)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <ng-template #noContacts>
      <div class="no-contacts-message">
        <mat-icon>contacts</mat-icon>
        <p>No emergency contacts on file</p>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
